import stock from '@/api/stock/stock-return'
import moment from 'moment'
import { join, isEmpty } from 'lodash'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  branch_id: [],
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date){
    state.dateRange = date
  },
  SET_BRANCH_ID(state, value){
    state.branch_id = value
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          date_between: join(context.state.dateRange, ','),
        }
      },
      attrubutes
    )
    return stock.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return stock.store(data)
  },
  update(context, { id, data }) {
    return stock.update(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await stock.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id){
    return stock.destroy(id)
  },
  findProduct(context, id){
    return stock.findProduct(id)
  },
  getCustomer(context, id){
    return stock.getCustomer(id)
  },
  getEmployee(context){
    return stock.getEmployee()
  }
}
